import { getBaseUrl } from './config'

export const APIEndPoints: any = {}

const REACT_APP_USE_NEW_LOV_API = window?._env_?.REACT_APP_USE_NEW_LOV_API === 'true'

export const refreshAPIEndpoints = () => {
  const sitUrl = getBaseUrl()
  Object.assign(APIEndPoints, {
    login: `${sitUrl}jfs/auth/login`,
    getMenuInfo: `${sitUrl}jfs/adminportal/user`,
    authAccessConfig: `${sitUrl}jfs/auth/access-config`,

    appAuth: 'jfs/v1/app/authenticate',
    userAuth: 'jfs/v1/user/authenticate',
    registerUser: 'jfs/v1/s2auth/user',
    appSessionExtend: 'jfs/v1/app/authenticate',
    userSessionExtend: 'jfs/v1/user/authenticate',
    appExpire: 'jfs/v1/app/session/expire',
    logout: 'jfs/v1/user/session/expire',

    entityMasterGetById: `${sitUrl}jfs/adminportal/api/v1.0/entity/`,
    entityMasterAdd: `${sitUrl}jfs/adminportal/api/v1.0/entity/new`,
    entityMasterGetAll: `${sitUrl}jfs/adminportal/api/v1.0/entity/findAll`,
    entityMasterUpdate: `${sitUrl}jfs/adminportal/api/v1.0/entity/update`,
    entityDelete: `${sitUrl}jfs/adminportal/api/v1.0/entity/delete`,
    entityIdNameMap: `${sitUrl}jfs/adminportal/api/v1.0/entity/id-name`,
    syncPam: `${sitUrl}jfs/adminportal/api/v1.0/merchant/pam/config-sync`,
    nBMappingByEntity: `${sitUrl}jfs/adminportal/api/v1.0/entity/nb-mapping/`,
    nBMappingById: `${sitUrl}jfs/adminportal/api/v1.0/entity/nb-mapping`,
    cardMappingByEntity: `${sitUrl}jfs/adminportal/api/v1.0/entity/card-mapping/`,
    cardMappingById: `${sitUrl}jfs/adminportal/api/v1.0/entity/card-mapping`,
    addNBMapping: `${sitUrl}jfs/adminportal/api/v1.0/entity/nb-mapping/new`,
    newCardMapping: `${sitUrl}jfs/adminportal/api/v1.0/entity/card-mapping/new`,
    deleteCardMapping: `${sitUrl}jfs/adminportal/api/v1.0/entity/card-mapping/delete`,
    deleteNBMapping: `${sitUrl}jfs/adminportal/api/v1.0/entity/nb-mapping/delete`,
    updateCardMapping: `${sitUrl}jfs/adminportal/api/v1.0/entity/card-mapping/update`,
    updateNBMapping: `${sitUrl}jfs/adminportal/api/v1.0/entity/nb-mapping/update`,
    entityMasterApprovals: `${sitUrl}jfs/adminportal/api/v1.0/entity/pending-approvals`,
    cardMappingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/entity/card-mapping/pending-approvals`,
    nBMappingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/entity/nb-mapping/pending-approvals`,
    entityMasterProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/entity/process-approval`,
    cardMappingProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/entity/card-mapping/process-approval`,
    nBMappingProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/entity/nb-mapping/process-approval`,

    getAllMerchantMapping: `${sitUrl}jfs/adminportal/api/v1.0/merchant/fetchAllMidMapping`,
    getMerchantMappingById: `${sitUrl}jfs/adminportal/api/v1.0/merchant/getById`,
    addMerchantMapping: `${sitUrl}jfs/adminportal/api/v1.0/merchant/add`,
    updateMerchantMapping: `${sitUrl}jfs/adminportal/api/v1.0/merchant/update`,
    merchantMappingPendingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/merchant/pending-approvals`,
    merchantMappingProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/merchant/process-approval`,
    deleteMerchantMapping: `${sitUrl}jfs/adminportal/api/v1.0/merchant/delete`,
    deviceMappings: `${sitUrl}jfs/adminportal/api/v1.0/merchant/device-mappings`,
    searchDeviceMappings: `${sitUrl}jfs/v1/merchant/ams/terminal/device/search`,
    delink: `${sitUrl}jfs/v1/terminal/device/update`,
    modifyDevice: `${sitUrl}jfs/ems/v1/device/modifydevice`,
    voiceBoxDlink: `${sitUrl}jfs/v1/merchant/ams/device/delink`,
    //voiceBoxDlink: 'http://localhost:8006/jfs/v1/merchant/ams/device/delink',
    link: `${sitUrl}jfs/v1/terminal/device/map`,
    codeNames: `${sitUrl}jfs/adminportal/api/v1.0/banking-code/code-name`,

    bulkOnboardStores: `${sitUrl}jfs/v1/terminal/saveStoreCode`,
    bulkEMSOnboardStores: `${sitUrl}jfs/ems/v1/storecode/create`,
    bulkOnboardInstitutes: `${sitUrl}jfs/v1/terminal/saveInstitute`,
    bulkEMSOnboardInstitutes: `${sitUrl}jfs/ems/v1/institution/create`,

    staticRoutingGetById: `${sitUrl}jfs/adminportal/api/v1.0/rule/getById`,
    getAllStaticRouting: `${sitUrl}jfs/adminportal/api/v1.0/rule/getAllById`,
    staticRoutingAdd: `${sitUrl}jfs/adminportal/api/v1.0/rule/add`,
    staticRoutingUpdate: `${sitUrl}jfs/adminportal/api/v1.0/rule/update`,
    staticRoutingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/rule/pending-approvals`,
    staticRoutingProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/rule/process-approval`,
    deleteStaticRouting: `${sitUrl}jfs/adminportal/api/v1.0/rule/delete`,
    routingFileApproval: `${sitUrl}jfs/adminportal/api/v1.0/routing-file/pending-approvals`,
    routingFileUploadApproval: `${sitUrl}jfs/adminportal/api/v1.0/routing-file/process-approval`,
    fileRoutingGetById: `${sitUrl}jfs/adminportal/api/v1.0/routing-file/getById`,
    fetchDynamicRouteConfig: `${sitUrl}jfs/adminportal/api/v1.0/dynamicRoutingConfig/fetch`,
    updateDynamicRouteConfig: `${sitUrl}jfs/adminportal/api/v1.0/dynamicRoutingConfig/upsert`,
    updateRoutingStatus: `${sitUrl}jfs/adminportal/api/v1.0/dynamicRoutingConfig/manageStatus`,
    addGroup: `${sitUrl}jfs/adminportal/user/group/add`,
    getGroups: `${sitUrl}jfs/adminportal/user/group/all`,
    deleteGroup: `${sitUrl}jfs/adminportal/user/group/delete`,
    updateGroup: `${sitUrl}jfs/adminportal/user/group/update`,

    getAllUsers: `${sitUrl}jfs/adminportal/user/all`,
    deleteUser: `${sitUrl}jfs/adminportal/user`,
    updateUserGroup: `${sitUrl}user/update/group`,
    updateUser: `${sitUrl}jfs/adminportal/user/update`,
    addUser: `${sitUrl}jfs/adminportal/user/new`,
    getGroupIdName: `${sitUrl}jfs/adminportal/user/group/id-name`,

    routingPackageGetAll: `${sitUrl}jfs/adminportal/api/v1.0/package/getAllById`,
    routingPackageGetById: `${sitUrl}jfs/adminportal/api/v1.0/package/getById`,
    routingPackageCreate: `${sitUrl}jfs/adminportal/api/v1.0/package/add`,
    routingPackageDelete: `${sitUrl}jfs/adminportal/api/v1.0/package/delete`,
    routingPackageUpdate: `${sitUrl}jfs/adminportal/api/v1.0/package/update`,
    routingPendingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/package/pending-approvals`,
    routingProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/package/process-approval`,
    routingPackageNames: `${sitUrl}jfs/adminportal/api/v1.0/package/getAllPackages`,

    routingPack2InstCreate: `${sitUrl}jfs/adminportal/api/v1.0/package-inst/add`,
    routingPack2InstUpdate: `${sitUrl}jfs/adminportal/api/v1.0/package-inst/update`,
    routingPack2InstDelete: `${sitUrl}jfs/adminportal/api/v1.0/package-inst/delete`,
    routingPack2InstGetById: `${sitUrl}jfs/adminportal/api/v1.0/package-inst/getById`,
    routingPack2InstGetAll: `${sitUrl}jfs/adminportal/api/v1.0/package-inst/getAllById`,
    routingPack2InstPendingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/package-inst/pending-approvals`,
    routingPack2InstProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/package-inst/process-approval`,

    routingMid2PackMerchantVerify: `${sitUrl}jfs/adminportal/api/v1.0/package-mid/getMids`,
    routingMid2PackCreate: `${sitUrl}jfs/adminportal/api/v1.0/package-mid/add`,
    routingMid2PackUpdate: `${sitUrl}jfs/adminportal/api/v1.0/package-mid/update`,
    routingMid2PackDelete: `${sitUrl}jfs/adminportal/api/v1.0/package-mid/delete`,
    routingMid2PackGetById: `${sitUrl}jfs/adminportal/api/v1.0/package-mid/getById`,
    routingMid2PackGetAll: `${sitUrl}jfs/adminportal/api/v1.0/package-mid/getAllById`,
    routingMid2PackPendingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/package-mid/pending-approvals`,
    routingMid2PackProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/package-mid/process-approval`,

    getPayerBanks: `${sitUrl}jfs/adminportal/api/v1.0/rule/getPayerBankIds`,
    getAllProcessors: `${sitUrl}jfs/adminportal/api/v1.0/entity/getAllProcessors`, // TODO:
    getAllEntities: `${sitUrl}jfs/adminportal/api/v1.0/entity/getAllEntities`, // TODO:

    addFileRule: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/add`,
    updateFileRule: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/update`,
    deleteFileRule: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/delete`,
    checkFileUpdate: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/checkUpdate`,
    checkFileDelete: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/checkDelete`,
    generateFile: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/generateFile`,
    getAllFileNames: `${sitUrl}jfs/adminportal/api/v1.0/package-inst/getFileNames`,
    getAllRules: `${sitUrl}jfs/adminportal/api/v1.0/rule/getRules`,
    processApprovalsOfFile: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/process-approval`,
    getFilesById: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/getById`,
    pendingApprovalsOfFiles: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/pending-approvals`,
    getFiles: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/getFiles`,
    getAllByFile: `${sitUrl}jfs/adminportal/api/v1.0/package-rule/getAllByFile`,

    getAllFiles: `${sitUrl}jfs/adminportal/api/v1.0/routing-file/all`,

    uploadFile: `${sitUrl}jfs/adminportal/api/v1.0/routing-file/upload`,
    bankCodeAdd: `${sitUrl}jfs/adminportal/api/v1.0/banking-code/new`,
    bankCodeUpdate: `${sitUrl}jfs/adminportal/api/v1.0/banking-code/update`,
    bankCodeDelete: `${sitUrl}jfs/adminportal/api/v1.0/banking-code/delete`,
    bankCodeGetAll: `${sitUrl}jfs/adminportal/api/v1.0/banking-code/all`,
    bankingCodeById: `${sitUrl}jfs/adminportal/api/v1.0/banking-code/`,
    pendingApprovalsOfBankingCodes: `${sitUrl}jfs/adminportal/api/v1.0/banking-code/pending-approvals`,
    bankingCodeProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/banking-code/process-approval`,
    bankingCodeApprovalById: `${sitUrl}jfs/adminportal/api/v1.0/banking-code/`,
    pendingApprovalsOfMerchantPayout: `${sitUrl}jfs/adminportal/api/v1.0/payout/pending-approvals`,
    processApprovalsOfMerchantPayout: `${sitUrl}jfs/adminportal/api/v1.0/ess/risk-controls/merchant/process-approval`,

    fileDownload: `${sitUrl}jfs/adminportal/api/v1.0/routing-file/download`,

    searchMerchant: `${sitUrl}jfs/v1/merchant/searchMerchant`,
    verifyMerchant: `${sitUrl}jfs/v1/merchant/verifyMerchant`,

    insertMerchant: `${sitUrl}jfs/v1/merchant/insert`,
    addMerchantConfig: `${sitUrl}jfs/v1/merchant/config/insert`,
    addMerchantConfigList: `${sitUrl}jfs/v1/merchant/configlist/insert`,
    addMerchantVpa: `${sitUrl}jfs/v1/create/vpa`,
    generateQr: `${sitUrl}jfs/v1/merchant/qr`,

    //API config
    getAllApisListByChannelId: '/jfs/v1/profile/mapping/list', //This API is used to fetch all APIs list registered against an profileName. => List of all api's
    updateProfileApisStatus: '/jfs/v1/profile/mapping/update', //This API is used to update an Application Profile API Mapping. ?
    getApiMasterList: '/jfs/v1/api/master/view', //Api master tab list api
    getApiMappingList: '/jfs/v1/api/mapping/list', //Api mapping list to check has access

    // use in create and update flow api config
    createApiMapping: '/jfs/v1/api/mapping', //Create api mapping in api config in create flow
    updateApiMapping: '/jfs/v1/api/mapping/update', //Providing access/revoking to channel id for api id

    getProfileApiAccess: '/jfs/v1/api/mapping/profileList', //This API is used to fetch all the profiles if has access/not for a given Channel ID.

    getMasVpas: `${sitUrl}jfs/v1/merchant/vpa/mas`,
    getMmsVpas: `${sitUrl}jfs/v1/merchant/vpa/mms`,
    saveOnboardingData: `${sitUrl}jfs/v1/merchant/onboard/save`,
    saveEmiConfig: `${sitUrl}jfs/v1/merchant/saveEmiInfo`,
    insertCso: `${sitUrl}jfs/v1/onboardCso`,
    grantPermissions: `${sitUrl}payments/eos/v1/entity/user`,

    //Submit Bulk Entity File
    submitFileForBulkEntityCreation: `${sitUrl}jfs/v1/submitFileForBulkEntityCreation`,
    getUploadedFileDetailsData: `${sitUrl}jfs/v1/getUploadedFileDetailsData`,
    uploadedFileHistory: `${sitUrl}jfs/v1/uploadedFileHistory`,
    fetchUploadedExcelFileDetailWithId: `${sitUrl}jfs/v1/fetchUploadedExcelFileDetailWithId`,

    generateSalesRecord: `${sitUrl}jfs/v1/merchant/ams/device/generateBillingReport`,
    downloadFinHubRecords: `${sitUrl}jfs/v1/merchant/ams/device/downloadBillingReport`,

    //FFS
    createEntity: '/jfs/v1/ffs/submit',
    checkStatusCreateEntity: '/jfs/v1/ffs/search',

    //EMS
    createGroup: '/jfs/ems/v1/group/create',
    createSubGroup: '/jfs/ems/v1/group/create',
    getEntityDetails: '/jfs/ems/v1/entity/getentity',

    updateGroupSubGroup: '/jfs/ems/v1/group/update',

    // searchDevices: `/ems/v1/device/search`,

    getDevicesGql: '/jfs/ems/v1/entity/getdevices',

    searchEntity: '/jfs/ems/v1/entity/search',

    searchEntityPPV2: '/jfs/ems/v2/entity/search',

    getGroupList: '/jfs/ems/v1/group/',
    getSubGroupList: '/jfs/ems/v1/group/subgroup',

    linkUnlinkMerchantWithDevice: '/jfs/ems/v1/device/merchant',
    // linkUnlinkTerminal: `/ems/v1/device/terminal`,

    getConfig: '/jfs/ems/v1/entity/config/getconfig',

    createConfig: '/jfs/ems/v1/entity/config/create',

    removeConfig: '/jfs/ems/v1/entity/config/remove',

    getPaymentInstruments: REACT_APP_USE_NEW_LOV_API
      ? '/payments/ems/v1/lov/paymentInstrument/getList'
      : '/jfs/v1/mdm/paymentInstrument/getList',

    getCardSchemeList: REACT_APP_USE_NEW_LOV_API ? '/payments/ems/v1/lov/card/getList' : '/jfs/v1/mdm/card/getList',

    searchConfigFromEms: '/jfs/ems/v1/entity/config/search',

    configUpdate: '/jfs/ems/v1/entity/config/update',

    getAllLovs: REACT_APP_USE_NEW_LOV_API ? '/payments/ems/v1/lov/gq/get' : '/jfs/v1/mdm/lov/gq/get',

    syncWithMas: '/jfs/ems/v1/entity/update',

    updateEntity: '/jfs/ems/v1/entity/update',

    getEmsCardList: '/jfs/ems/v1/card/config/search',
    saveCardList: '/jfs/ems/v1/card/config/save',
    updateEmsCards: '/jfs/ems/v1/card/config/update',

    sapLogin: `${sitUrl}jfs/adminportal/api/v1.0/merchant/sap-onboard/session`,
    sapCreateCustomer: `${sitUrl}jfs/adminportal/api/v1.0/merchant/sap-onboard/create-merchant`,

    getEmisTenures: `${sitUrl}emiTenures`,
    getMerchantQrByVpa: `${sitUrl}jfs/v1/merchant/getMerchantQrByVpa`,

    getInstruments: `${sitUrl}jfs/v1/merchant/data/getInstrumentsList`,
    getCardList: `${sitUrl}jfs/v1/merchant/data/getCardList`,

    cardsInsert: `${sitUrl}jfs/v1/merchant/cards/insert`,

    configInsert: `${sitUrl}jfs/v1/merchant/config/insert`,
    configListInsert: `${sitUrl}jfs/v1/merchant/configlist/insert`,

    uploadBulkOnboardingFile: `${sitUrl}jfs/adminportal/api/v1.0/bulk-onboarding-file/upload`,

    getBizProgDetailsFromMccCode: REACT_APP_USE_NEW_LOV_API
      ? '/payments/ems/v1/lov/mcc/getmccdetails'
      : '/jfs/v1/mdm/mcc/getmccdetails',

    getMdrDetails: REACT_APP_USE_NEW_LOV_API ? '/payments/ems/v1/lov/mdr/get' : '/jfs/v1/mdm/mdr/get',

    getAllBankDetailsByIFSC: REACT_APP_USE_NEW_LOV_API
      ? '/payments/ems/v1/lov/bankdetails/get'
      : '/jfs/v1/mdm/bankdetails/get',

    getprogrambymcc: REACT_APP_USE_NEW_LOV_API
      ? '/payments/ems/v1/lov/program/getprogrambymcc'
      : '/jfs/v1/mdm/program/getprogrambymcc',

    getProgramDetailsByProgramIds: REACT_APP_USE_NEW_LOV_API
      ? '/payments/ems/v1/lov/program/get'
      : '/jfs/v1/mdm/program/get',

    getKycDocumentCategories: REACT_APP_USE_NEW_LOV_API ? '/payments/ems/v1/lov/kyc/get' : '/jfs/v1/mdm/kyc/get',

    //CHECKER
    createGroup_camunda: 'jfs/eos/v1/group/create', // camunda
    createSubGroup_camunda: 'jfs/eos/v1/group/create', // camunda
    getGlobalCheckerList: 'jfs/eos/v1/application/list/global', // camunda
    makerApplicationQueue: 'jfs/eos/v1/application/list/createdBy', //camunda
    getMyCheckerList: 'jfs/eos/v1/application/list/claimed', //camunda checker application queue
    claimTask: 'jfs/eos/v1/application/claim', //camunda
    approveRejectTask: 'jfs/eos/v1/application/process', //camunda
    checkStatus: 'jfs/eos/v1/application/status', //camunda
    updateGroup_camunda: 'jfs/eos/v1/group/update', // camunda
    updateSubGroup_camunda: 'jfs/eos/v1/group/update', //camunda

    createEntity_camunda: 'jfs/eos/v1/entity/create',
    // updateEntity_camunda: 'jfs/eos/entity/update',

    applicationRetry: 'jfs/eos/v1/application/retry',

    // getGlobalSearchOnChecker: `${sitUrl}searchList`,

    configListMetaInsert: `${sitUrl}jfs/v1/merchant/configlist/meta/insert`,
    sampleFileDownload: `${sitUrl}jfs/v1/merchant/getSampleFile`,
    // merchant payout config
    retrieveMidPayoutConfig: `${sitUrl}jfs/adminportal/api/v1.0/payout/all`,
    updateMidPayoutConfig: `${sitUrl}jfs/adminportal/api/v1.0/ess/risk-controls/merchant/update`,
    addMidPayoutConfig: `${sitUrl}jfs/adminportal/api/v1.0/payout/add`,
    addBulkMidPayoutConfig: `${sitUrl}jfs/v1/entity/payout/config`,

    //liability config
    retrieveLiabilityMidPayoutConfig: `${sitUrl}jfs/v1/entity/account/retrieve`,
    updateLiabilityConfig: `${sitUrl}jfs/v1/entity/account/update`,
    addLiabilityConfig: `${sitUrl}jfs/v1/entity/account`,

    // payout frequency config
    addFreqConfig: `${sitUrl}jfs/v1/entity/payout/frequency`,
    retrieveFreqConfig: `${sitUrl}jfs/v1/entity/payout/frequency/retrieve`,
    //sourceaccconfig
    retriveSourceAccount: `${sitUrl}jfs/v1/jiopay/settlement/account/retrieve`,
    updateSourceAccount: `${sitUrl}jfs/v1/jiopay/settlement/account/update`,
    addSourceAccount: `${sitUrl}jfs/v1/jiopay/settlement/account`,
    getGroupIds: `${sitUrl}jfs/ems/v1/group/`,
    getSubGroupIds: `${sitUrl}jfs/ems/v1/group/subgroup`,

    //risk config
    searchTxns: `${sitUrl}jfs/v1/merchant/searchSettlementDetails`,
    holdOrRelease: `${sitUrl}jfs/adminportal/api/v1.0/ess/risk-controls/txn/update`,

    //cms update
    updateCms: `${sitUrl}jfs/adminportal/api/v1.0/ess/payout-cms/update`,

    //ess controls
    retreiveMids: `${sitUrl}core/jfs/v1/core/internal/settlement-config`,
    addMid: `${sitUrl}core/jfs/v1/core/internal/settlement-config/update`,

    //processingentity
    retrieveProcessingEntity: `${sitUrl}jfs/v1/jiopay/settlement/entity/retrieve`,
    addProcessingEntity: `${sitUrl}jfs/v1/jiopay/settlement/entity`,
    updateProcessingEntity: `${sitUrl}jfs/v1/jiopay/settlement/entity/update`,

    // credit debit enhancement
    initaiteCrDrAdjudtment: `${sitUrl}jfs/adminportal/api/v1.0/payout/adjustments/initiate`,
    crDrAdjudtmentPendingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/payout/adjustments/pending-approvals`,
    crDrAdjudtmentProcessApprovals: `${sitUrl}jfs/adminportal/api/v1.0/payout/adjustments/process-approval`,

    //BOS - Bulk Onboaridng System
    bulkOnboardUpload: `${sitUrl}jfs/bos/v1/entity/upload`,
    bulkOnboardUploadConfirm: 'jfs/bos/v1/entity/upload/confirm',
    bulkOnboardUploadList: 'jfs/bos/v1/entity/upload/list',
    bulkOnboardDeleteFile: 'jfs/bos/v1/entity/upload/delete',
    bulkOnboardFileDownload: 'jfs/bos/v1/entity/file/download',

    //Kyc JDMS Documentation
    downloadKycImage: '/jfs/ems/v1/kyc/files/download',
    getDocumentsList: '/jfs/ems/v1/kyc/documentnames',

    //pos
    fetchApprovals: `${sitUrl}jfs/v1/entity/epfa/fetch`,
    approveOrDeclinePos: `${sitUrl}jfs/v1/entity/epfa/checker`,

    //Fiu
    createUpdateDeleteFiu: '/jfs/eos/v1/audit/initiate',
    getFiuMakerList: 'jfs/payments/eos/api/v1/audit/my-queue',
    processFiu: '/jfs/eos/v1/workitem/process',
    fiuRetry: '/jfs/eos/v1/workitem/retry',
    export: '/jfs/bos/v1/export',

    //aadhar
    aadharRedactionInit: '/jfs/eos/v1/workitem/initiate',
    aadharRedactionProcess: '/jfs/eos/v1/workitem/process',
    aadharRedactionRetry: '/jfs/eos/v1/workitem/retry',

    // EMS Maker kyc apis
    getKycUploadId: '/jfs/ems/v1/kyc/kycuploadid',
    kycUpload: 'jfs/ems/v1/kyc/kycupload',
    kycListByUploadId: '/jfs/ems/v1/kyc/kycdocdetails',
    kycDownload: '/jfs/ems/v1/kyc/kycdocument',
    deleteKycDoc: '/jfs/ems/v1/kyc/deletedocument',
    getDeviceVariantListApi: '/jfs/v1/merchant/ams/asset/variant/list',
    deleteDeviceVariantApi: '/jfs/v1/merchant/ams/asset/variant/update',
    addDeviceVariantApi: '/jfs/v1/merchant/ams/asset/variant/add',
    getVariantPlanListApi: '/jfs/v1/merchant/ams/asset/plans/list',
    deleteDevicePlanApi: '/jfs/v1/merchant/ams/asset/plan/update',
    addDevicePlanApi: '/jfs/v1/merchant/ams/asset/plan/add',
    addVariantToMaster: '/jfs/v1/merchant/ams/asset/add',

    //post recon
    searchSettlementDetails: `${sitUrl}jfs/v1/merchant/searchSettlementDetails`,
    payoutGeneration: '/jfs/v1/entity/generatePayout',
    payoutUpdate: `${sitUrl}jfs/v1/entity/payout/update`,

    //bulk users
    onboardBulkUsersWithPermissions: `${sitUrl}jfs/v1/merchant/onboardNewMerchant`,

    //Risk controls maker checker
    riskControlTxnPendingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/ess/risk-controls/txn/pending-approvals`,
    riskControlTxnProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/ess/risk-controls/txn/process-approval`,

    // riskControlMerchantUpdate:
    riskControlMerchantPendingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/ess/risk-controls/merchant/pending-approvals`,
    riskControlMerchantProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/ess/risk-controls/merchant/process-approval`,

    //payout cms pending list and approve api
    payoutCmsPendingApprovals: `${sitUrl}jfs/adminportal/api/v1.0/ess/payout-cms/pending-approvals`,
    payoutCmsProcessApproval: `${sitUrl}jfs/adminportal/api/v1.0/ess/payout-cms/process-approval`,

    auditTrialList: `${sitUrl}jfs/adminportal/api/v1.0/audit/approval/get-all`,

    //fraud and risk
    uploadEvidence: `${sitUrl}jfs/adminportal/api/v1.0/risk/evidence/upload`,
    //https://sit-apig.jiomoney.com/jfsapig/jfs/adminportal/api/v1.0/risk/evidence/upload
    groupByRiskAudit: `${sitUrl}jfs/adminportal/api/v1.0/risk/merchant/list`,
    exportAuditHistory: `${sitUrl}jfs/adminportal/api/v1.0/risk/history/export`,
    downloadEvidence: `${sitUrl}jfs/adminportal/api/v1.0/risk/evidence/download`,
    riskAuditForAMid: `${sitUrl}jfs/adminportal/api/v1.0/risk/transaction/list`,
    groupByRiskTnxApi: `${sitUrl}jfs/v1/merchant/settlementDetailByStatus`,
    processTransactionApi: `${sitUrl}jfs/adminportal/api/v1.0/risk/process`,
    genericExportFile: `${sitUrl}jfs/adminportal/api/v1.0/export`,

    getGlobalEntityQueue: `${sitUrl}jfs/eos/api/v1/process/global-queue`,
    claimEntityTask: `${sitUrl}jfs/eos/api/v1/work-items/`,
    eosCreateWorkItem: `${sitUrl}jfs/eos/api/v1/process/ops/create`,
    getPincodeData: REACT_APP_USE_NEW_LOV_API ? `${sitUrl}payments/ems/v1/lov/pincode` : `${sitUrl}jfs/v1/mdm/pincode`,
    getMyEntityQueue: `${sitUrl}jfs/eos/api/v1/process/my-queue`,
    updateEntityStatus: `${sitUrl}jfs/eos/api/v1/work-items/`,
    getDedupe: `${sitUrl}jfs/eos/api/v1/process/dedupe`,
    eosEntityDetails: `${sitUrl}jfs/eos/api/v1/process/merchant/edit`,
    updateExistingEntity: `${sitUrl}jfs/eos/api/v1/process/ops/update`,
    riskMakerExistingEntity: `${sitUrl}jfs/eos/api/v1/process/risk/update`,
    getOnboardingIncidents: `${sitUrl}jfs/eos/api/v1/process/incidents`,
    resolveIncident: `${sitUrl}jfs/eos/api/v1/process/incidents/resolve`,
    interactionHistoryApi: `${sitUrl}jfs/eos/api/v1/process/audit`,
    downloadInteractionHistoryDocs: '/jfs/ems/v1/fraudAndRisk/documents/download',
    uploadInteractionHistoryFileApi: '/jfs/ems/v1/fraudAndRisk/documents/upload',
    getJobIdForExportApi: 'jfs/bos/v1/submit/job',
    getExportByJobIdStatus: 'jfs/bos/v1/jobProgress',
    downloadFileUsingJobId: 'jfs/bos/v1/jobResponse/download',
    getMerchantMappingApproval: `${sitUrl}jfs/eos/api/v1/merchant-config/checker/list`,
    getPosBatchMakerList: `${sitUrl}jfs/eos/api/v1/settlement/batch/summary`,
    getAllCheckerPOSBatchesApi: `${sitUrl}jfs/eos/api/v1/settlement/batch/process/checker`,
    getAllProcessingEntityConfig: `${sitUrl}jfs/adminportal/api/v1.0/routing/fetchAllProcessingEntityConfigs`,
    updateProcessingEntityConfig: `${sitUrl}jfs/eos/api/v1/processing-entity/process/initiate`,
    getEntityConfigApprovals: `${sitUrl}jfs/eos/api/v1/processing-entities/checker`,
    entityConfigApprovalActionApi: `${sitUrl}jfs/eos/api/v1/processing-entity/process/`,
    linkSQrs: `${sitUrl}jfs/v1/merchant/ams/device/pair`,
    delinkSQRs: `${sitUrl}jfs/v1/merchant/ams/device/unpair`,
    updateDeviceStatusApi: `${sitUrl}jfs/v2/merchant/ams/device/status/update`,
    getFiuCheckerList: 'jfs/payments/eos/api/v1/audit/global-queue',
  })
}
